import * as constants from "../contants/users-settings";

export const setTabs = (data) => ({
  type: constants.SET_TABS,
  payload: data
})
